import { render } from "./cover.vue?vue&type=template&id=bbf27a04&scoped=true&ts=true"
import script from "./cover.vue?vue&type=script&lang=ts"
export * from "./cover.vue?vue&type=script&lang=ts"

import "./cover.vue?vue&type=style&index=0&id=bbf27a04&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf27a04"]])

export default __exports__